"use client";
import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

export default function Scrolltext() {
    const items = [
        "Cinema's",
        "Watergames",
        "Electronic games",
        "Tasty Bytes",
        "Relaxations",
        "Endless Smile",
        "Thrills & adventures",
        "Event celebrations",
        "Memorable moments",
        "Fun for all"
    ];

    return (
        <section className="scroll-text-section">
            <div className="container-fluid p-0">
                <div className="marquee-wrapper">
                    <Marquee gradient={false} speed={50} pauseOnHover={true}>
                        {items.map((item, index) => (
                            <div key={index} className="marquee-item">
                                <span className="marquee-icon">
                                    <Sparkles size={24} fill="currentColor" />
                                </span>
                                <span className="marquee-text">{item}</span>
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </section>
    );
}

